export default "__VITE_ASSET__BjBMht9T__"